import kb from "./kb.json";
import seoData from "./seo-data";

export const { STATES_SEO, GLOSSARY_SEO, CONDITION_LABELS, PROJECT_TYPE_LABELS, PHASES, APPROVAL_OVERRIDES } = seoData;

export const slugify = (s) =>
  String(s).toLowerCase().replace(/&/g, " and ").replace(/[–—]/g, "-").normalize("NFKD")
    .replace(/[^\w\s-]/g, "").trim().replace(/[\s_]+/g, "-").replace(/-+/g, "-").slice(0, 80).replace(/-+$/, "");

export const truncate = (s, n = 140) => {
  const str = String(s || "");
  return str.length <= n ? str : str.slice(0, n - 1).replace(/\s+\S*$/, "") + "…";
};

export const APPROVALS = kb.approvals.map((a) => ({ ...a, slug: slugify(a.name) }));
export const RULES = kb.rules;

const bySlug = new Map(APPROVALS.map((a) => [a.slug, a]));
const byKey = new Map(APPROVALS.map((a) => [a.key, a]));
export const approvalBySlug = (s) => bySlug.get(s);
export const approvalByKey = (k) => byKey.get(k);

export function whenRequired(key) {
  const out = [];
  for (const r of RULES.filter((r) => (r.approvals || []).includes(key))) {
    const conds = (r.conditions || []).map((c) => {
      const fn = CONDITION_LABELS[c.field];
      return fn ? fn(c.values || [], PROJECT_TYPE_LABELS) : `${c.field}: ${(c.values || []).join(" / ")}`;
    });
    const scope = r.scope === "state" && r.states?.length ? ` (state-specific: ${r.states.join(", ")})` : "";
    out.push({ name: r.name, text: conds.join("; ") + scope, logic: r.logic });
  }
  return out;
}
